"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { CirclePlay, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function BespokeExperiences() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const services = [{
    id: 1,
    title: "Full-Service Flower Bar Rentals"
  }, {
    id: 2,
    title: "Pop-Up Bouquet Bar Experiences"
  }, {
    id: 3,
    title: "Custom Event Floral Design"
  }, {
    id: 4,
    title: "Interactive Guest Bouquet Building"
  }, {
    id: 5,
    title: "Premium Fresh Bloom Selection"
  }, {
    id: 6,
    title: "Professional On-Site Floral Stylists"
  }];
  return <section data-section-id="261584" id="bespoke-experiences" className="bg-background text-foreground py-12 md:py-20">
      <div className="page-container">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
          
          <div className="flex justify-center md:justify-start">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691064/img/711694771_943300942099976_4582882663885298918_n.png" alt="Elegant mobile flower bar with blush and rose blooms" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691064/img/luxury_flower_bar_setup.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691064/img/luxury_flower_bar_setup.png-wvc-sizes" loading="lazy" decoding="async" className="rounded-lg shadow-lg max-w-full h-auto border border-secondary/20" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691064/img/711694771_943300942099976_4582882663885298918_n.png" src="https://babebloombarco.com/wp-content/uploads/2026/06/711694771_943300942099976_4582882663885298918_n.jpg" />
          </div>

          <div ref={contentRef} className={`transition-all duration-700 transform ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="mb-8">
              <h2 className="font-default text-3xl md:text-4xl font-bold text-primary mb-2 tracking-wide">Floral Bar Experiences</h2>
              <div className="w-16 h-1 bg-secondary rounded-lg"></div>
            </div>

            <ul className="space-y-4 mb-8">
              {services.map((service, i) => <li key={service.id} data-index={i} className="flex items-center gap-3">
                  <div className="flex-shrink-0">
                    <CirclePlay className="lucide lucide-circle-play w-6 h-6 !text-[rgba(245,123,168,1)]" style={{
                  color: "var(--secondary)"
                }} fill="currentColor" />
                  </div>
                  <span className="font-default text-muted-foreground text-base md:text-lg">
                    {service.title}
                  </span>
                </li>)}
            </ul>

            <Link to="/ContactPage">
              <Button variant="default" className="bg-primary hover:bg-primary/90 text-primary-foreground font-default font-semibold rounded-lg px-6 py-3 flex items-center gap-2 transition-colors duration-300 shadow-md">
                <Phone className="w-5 h-5" />
                Inquire Today
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}